import React, { useMemo } from 'react'
import { StatsigProvider } from '@statsig/react-bindings'
import { useAuth } from './auth/Auth.hook'

const StatsigComponent = ({ children }) => {
  const { userInfo } = useAuth()

  const user = userInfo?.user
  const userId = user?.id
  const userEmail = user?.email
  const clientId = user?.clientId
  const clientName = user?.client?.name
  const roleName = user?.role?.name
  const clientNumber = user?.client?.clientNumber

  const userStatsig = useMemo(() => {
    if (!userId) return null
    return {
      userID: `${userId}`,
      email: userEmail,
      custom: {
        clientId: `${clientId}`,
        clientName,
        role: roleName,
        clientNumber
      }
    }
  }, [userId, userEmail, clientId, clientName, roleName, clientNumber])

  const optionStatsig = useMemo(
    () => ({
      environment: { tier: `${import.meta.env.VITE_ENV}` },
      networkConfig: { networkTimeoutMs: 5000 }
    }),
    []
  )

  if (!userStatsig) {
    return <>{children}</>
  }

  return (
    <StatsigProvider sdkKey={import.meta.env.VITE_KEY_STACKSING} user={userStatsig} options={optionStatsig}>
      {children}
    </StatsigProvider>
  )
}

export default StatsigComponent
